"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const BUTTON_OFFSET = 70;
function ColorsOptions({ colors, currentColor, active, className, onSelect, }) {
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, "data-e2e": 'ColorsOptions_Container', children: colors.map((color, index) => {
            const offset = (colors.length - index) * BUTTON_OFFSET;
            return ((0, jsx_runtime_1.jsx)(ui_1.PushInAnimation, { delay: 200, "data-e2e": 'ColorsOptions_PushInAnimation', children: (0, jsx_runtime_1.jsx)(Button, { "$color": color, "$selected": color === currentColor, "$active": active, "$offset": offset, onClick: () => onSelect(color), "data-e2e": 'ColorsOptions_Button' }) }, index));
        }) }));
}
exports.default = ColorsOptions;
const Container = styled_components_1.default.div `
  display: flex;

  padding: 5px 0 5px 5px;

  overflow: hidden;
`;
const Button = (0, styled_components_1.default)(ui_1.BaseButton) `
  position: relative;

  width: 30px;
  height: 30px;

  margin: auto 30px auto 0;
  padding: 0;

  background-color: ${props => props.$color};

  border-radius: 50%;

  transform: translateX(
    ${({ $active, $offset }) => ($active ? '0' : `${$offset}px`)}
  );

  transition: transform 0.3s;

  &::before {
    position: absolute;
    top: -4px;
    right: -4px;
    bottom: -4px;
    left: -4px;

    border: 4px solid
      ${props => props.$selected ? props.theme.screens.ratingBorder : 'transparent'};
    border-radius: 50%;

    content: ' ';
  }
`;
